import { timer } from 'rxjs';
import { take, map } from 'rxjs/operators';
import * as i0 from "@angular/core";
var Countdown = /** @class */ (function () {
    function Countdown(key) {
        this.key = key;
        this.total = 0;
        this.count = 0;
        this.paused = false;
    }
    Countdown.prototype.start = function (count) {
        var _this = this;
        this.paused = false;
        this.count = count + 1;
        this.total = count;
        this.countDown = timer(0, 1000).pipe(take(this.count), map(function (x) {
            if (!_this.paused) {
                _this.count--;
            }
            return _this.count;
        }));
    };
    Countdown.prototype.pause = function () {
        this.paused = true;
    };
    Countdown.prototype.resume = function () {
        this.paused = false;
    };
    return Countdown;
}());
export { Countdown };
var CountdownService = /** @class */ (function () {
    function CountdownService() {
        this.countdowns = [];
    }
    CountdownService.prototype.start = function (key, count) {
        var counter = this.getTimer(key);
        counter.start(count);
        return counter.countDown;
    };
    CountdownService.prototype.stop = function (key) {
        var counter = this.getTimer(key);
        var idx = this.countdowns.indexOf(counter);
        if (idx >= 0) {
            this.countdowns.splice(idx, 1);
        }
    };
    CountdownService.prototype.pause = function (key) {
        var counter = this.getTimer(key);
        counter.pause();
    };
    CountdownService.prototype.resume = function (key) {
        var counter = this.getTimer(key);
        counter.resume();
    };
    CountdownService.prototype.getTimer = function (key) {
        return this.addCountdown(key);
    };
    CountdownService.prototype.addCountdown = function (key) {
        var counter = this.countdowns.find(function (counter) { return counter.key === key; });
        if (!counter) {
            counter = new Countdown(key);
            this.countdowns.push(counter);
        }
        return counter;
    };
    CountdownService.ngInjectableDef = i0.defineInjectable({ factory: function CountdownService_Factory() { return new CountdownService(); }, token: CountdownService, providedIn: "root" });
    return CountdownService;
}());
export { CountdownService };
